import React, { useState, useEffect } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
  Card,
  CardContent,
  useMediaQuery,
  Container,
  Paper,
  Button,
  Stack,
  CircularProgress,
} from "@mui/material";
import HeyzineFlipbook from "../components/HeyzineFlipbook.js";
import aboutBG from "../assets/about_BG.png";

export default function Catalogs() {
  const isSmallScreen = useMediaQuery("(max-width:900px)");


  return (
    <Container sx={{ paddingTop: 10, paddingBottom: 4 }}>
{/* Flipbook Section (unchanged) */}
      <Grid
        width={"100%"}
        height={isSmallScreen ? 600 : 600}
        paddingTop={3.5}
      >
        <HeyzineFlipbook />
      </Grid>
    </Container>
  );
}